var map = {
	"./anguilla.jpg": "0142",
	"./antiguaAndBarbuda.jpg": "1772",
	"./aruba.jpg": "4459",
	"./bahamas.jpg": "66cc",
	"./bahrain.jpg": "5edd",
	"./barbados.jpg": "df7b",
	"./belize.jpg": "577a",
	"./bermuda.jpg": "184c",
	"./britishVirginIslands.jpg": "613e",
	"./caboVerde.jpg": "14af",
	"./caymanIslands.jpg": "bef4",
	"./comoros.jpg": "ef41",
	"./cookIslands.jpg": "932b",
	"./cookIslandsBig.jpg": "092c",
	"./cuba.jpg": "3cda",
	"./curacao.jpg": "22f8",
	"./dominica.jpg": "22c1",
	"./dominicanRepublic.jpg": "56c5",
	"./fiji.jpg": "7d41",
	"./grenada.jpg": "f5f7",
	"./guineaBissau.jpg": "d181",
	"./guyana.jpg": "cf43",
	"./haiti.jpg": "91b0",
	"./jamaica.jpg": "52ee",
	"./kiribati.jpg": "7ff2",
	"./kittsAndNevis.jpg": "5ee0",
	"./maldives.jpg": "5f50",
	"./marshallIslands.jpg": "ce90",
	"./mauritius.jpg": "aac6",
	"./micronesia.jpg": "ff92",
	"./montserrat.jpg": "15d7",
	"./nauru.jpg": "ad68c",
	"./niue.jpg": "a744",
	"./palau.jpg": "4bff",
	"./papuaNewGuinea.jpg": "8ff8",
	"./saintLucia.jpg": "7ff7",
	"./samoa.jpg": "c164",
	"./saoTomeAndPrincipe.jpg": "8129",
	"./seychelles.jpg": "93a2",
	"./singapore.jpg": "d7de",
	"./sintMaarten.jpg": "e812",
	"./solomonIslands.jpg": "b6f1",
	"./stVincent.jpg": "b91f",
	"./suriname.jpg": "3efc",
	"./timorLeste.jpg": "0107",
	"./tokelau.jpg": "deba",
	"./tonga.jpg": "74fe",
	"./trinidadAndTobago.jpg": "c84c",
	"./turksAndCaicos.jpg": "7f3a",
	"./tuvalu.jpg": "010b",
	"./vanuatu.jpg": "ef52"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ea92";